import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const PatientsEarlyAppointmentCheckReminder = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const hours = now.getHours();
      const today = now.toDateString();

      const lastDismissed = localStorage.getItem("patientsEarlyAppointmentCheckReminderDismissed");
      if (hours >= 12 && lastDismissed !== today) {
        setOpen(true);
      }
    };

    const interval = setInterval(checkTime, 60000); // Check every minute
    checkTime(); // Initial check on mount

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("patientsEarlyAppointmentCheckReminderDismissed", new Date().toDateString());
  };

  return (
    <Dialog
      open={open}
      onClose={() => { }} // Prevent closing on backdrop click
      disableEscapeKeyDown
      slotProps={{
        backdrop: {
          onClick: (e) => e.stopPropagation(),
        },
      }}
      aria-labelledby="appointment-reminder-title"
      aria-describedby="appointment-reminder-description"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          padding: 2,
          maxWidth: 600,
        },
      }}
    >
      <DialogTitle id="appointment-reminder-title">
        <Typography variant="h6" component="span" color="primary">
          🕒 Patients' Early Appointment Check – Reminder
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="appointment-reminder-description" color="text.primary">
          Kindly review the Appointment List to identify patients who have requested early appointments.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          sx={{ minWidth: 80 }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PatientsEarlyAppointmentCheckReminder;